import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AppUser } from 'src/app/shared/models/app-user';
import { WelcomeDashboard } from '../../state/welcome/reducer';

@Component({
  selector: 'app-welcome-component',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  standalone: false
})
export class WelcomeComponent implements OnInit, OnChanges {
  @Input() busy = false;
  @Input() loading = false;
  @Input() saving = false;

  @Input() user: AppUser;

  @Input() loadingDashboards = false;
  @Input() dashboards: WelcomeDashboard[] = [];

  @Input() selectedDashboardId: number = 0;
  @Output() selectDashboard = new EventEmitter<WelcomeDashboard>();

  @Output() addToHome = new EventEmitter<WelcomeDashboard>();

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
  }
};

